import { t } from "i18next";
import React from "react";
import ReactDOM from "react-dom";
import { Link, useNavigate } from "react-router-dom";
import AuthContext from "../../context/AuthContext";
import { useContextSelector } from "use-context-selector";
import OutsideClickHandler from "react-outside-click-handler";
import ConditionalOutsideClick from "../../component/ConditionalOutsideClick";
import moment from "moment";
const Profile = () => {
  const user = useContextSelector(AuthContext, (ctx) => {
    return ctx.user;
  });
  const profileData = useContextSelector(AuthContext, (ctx) => {
    return ctx.profileData;
  });
  const navigate = useNavigate();
  return ReactDOM.createPortal(
    <app-popup-page
      _ngcontent-serverapp-c4268204220
      className="ng-tns-c4268204220-0 popup-page-wrapper active"
      _nghost-serverapp-c2790459173
    >
      <div
        _ngcontent-serverapp-c2790459173
        className="popup-page popup-page--active popup-page--align-top"
      >
        <div
          _ngcontent-serverapp-c2790459173
          className="popup-page__backdrop"
        />{" "}
        <ConditionalOutsideClick onOutsideClick={() => navigate(-1)}>
          <div
            _ngcontent-serverapp-c2790459173
            className="popup-page__main popup-page-main popup-page-main--show"
          >
            <div
              _ngcontent-serverapp-c2790459173
              className="popup-page-main__header"
            >
              <div
                _ngcontent-serverapp-c2790459173
                className="popup-page-main__title"
              >
                {t("PersonalInformation")}
              </div>
              <div
                onClick={() => navigate("/")}
                _ngcontent-serverapp-c2790459173
                className="popup-page-main__close ng-star-inserted"
              />
            </div>
            <div
              _ngcontent-serverapp-c3037944270
              className="popup-page-main__container"
            >
              <div
                _ngcontent-serverapp-c3037944270
                className="content mcd-style player-content new-profile third-party-login"
              >
                <ng-component className="ng-star-inserted">
                  <router-outlet />
                  <ng-component
                    _nghost-serverapp-c1360517466
                    className="ng-tns-c1360517466-29 ng-star-inserted"
                  >
                    <div
                      _ngcontent-serverapp-c1360517466
                      className="ng-tns-c1360517466-29 player-vip-lv1 ng-star-inserted"
                    >
                      <div
                        _ngcontent-serverapp-c1360517466
                        className="ng-tns-c1360517466-29 player-info-vip"
                        style={{
                          "background-image":
                            'url("/assets/NewImages/vip-card-bg-1.webp?v=1776751585885")',
                        }}
                      >
                        <div
                          _ngcontent-serverapp-c1360517466
                          className="member-pic ng-tns-c1360517466-29"
                        >
                          <span
                            _ngcontent-serverapp-c1360517466
                            className="item-icon ng-tns-c1360517466-29 ng-star-inserted"
                            style={{
                              "background-image":
                                'url("/assets/NewImages/memberpic-lv1.webp?v=1776751585885")',
                            }}
                          />
                          {/**/}
                          {/**/}
                          {/**/}
                          {/**/}
                        </div>
                      </div>
                      <div
                        _ngcontent-serverapp-c1360517466
                        className="membername-wrap ng-tns-c1360517466-29"
                      >
                        <div
                          _ngcontent-serverapp-c1360517466
                          className="membername ng-tns-c1360517466-29"
                        >
                          {profileData?.username}
                        </div>
                        <div
                          _ngcontent-serverapp-c1360517466
                          className="level ng-tns-c1360517466-29 ng-star-inserted"
                        >
                          {" "}
                          Normal{" "}
                        </div>
                        {/**/}
                        <br
                          _ngcontent-serverapp-c1360517466
                          className="ng-tns-c1360517466-29"
                        />
                        <div
                          _ngcontent-serverapp-c1360517466
                          className="register-date ng-tns-c1360517466-29"
                        >
                          Date Registered :{" "}
                          <i
                            _ngcontent-serverapp-c1360517466
                            className="ng-tns-c1360517466-29"
                          >
                            {moment(profileData?.createdAt).format('YYYY/MM/DD')}
                          </i>
                        </div>
                      </div>
                    </div>
                    <div
                      _ngcontent-serverapp-c1360517466
                      id="profile-vip-div"
                      className="menu-box ng-tns-c1360517466-29 ng-star-inserted"
                    >
                      <div
                        _ngcontent-serverapp-c1360517466
                        className="vip-area-group ng-tns-c1360517466-29"
                      >
                        <div
                          _ngcontent-serverapp-c1360517466
                          className="left-box ng-tns-c1360517466-29"
                        >
                          <div
                            _ngcontent-serverapp-c1360517466
                            className="item ng-tns-c1360517466-29"
                          >
                            <h3
                              _ngcontent-serverapp-c1360517466
                              className="ng-tns-c1360517466-29"
                            >
                              VIP Points (VP)
                            </h3>
                            <div
                              _ngcontent-serverapp-c1360517466
                              className="points-number ng-tns-c1360517466-29"
                            >
                              0
                            </div>
                          </div>
                        </div>
                        <div
                          _ngcontent-serverapp-c1360517466
                          className="right-box ng-tns-c1360517466-29"
                        >
                          <a
                            _ngcontent-serverapp-c1360517466
                            className="goto-myvip ng-tns-c1360517466-29 ng-star-inserted"
                            href="/bd/en/member/vip-points-exchange(popup:member/new-profile-info)"
                          >
                            <div
                              _ngcontent-serverapp-c1360517466
                              className="myvip-text ng-tns-c1360517466-29"
                            >
                              <span
                                _ngcontent-serverapp-c1360517466
                                className="ng-tns-c1360517466-29"
                              >
                                {" "}
                                My VIP{" "}
                              </span>
                              <span
                                _ngcontent-serverapp-c1360517466
                                className="item-icon ng-tns-c1360517466-29"
                                style={{
                                  "mask-image":
                                    'url("/assets/NewImages/icon-arrow.webp?v=1776751585885")',
                                }}
                              />
                            </div>
                          </a>
                          {/**/}
                        </div>
                      </div>
                    </div>
                    {/**/}
                    {/**/}
                    {/**/}
                    {/**/}
                    {/**/}
                    <div
                      _ngcontent-serverapp-c1360517466
                      className="ng-tns-c1360517466-29 ng-trigger ng-trigger-slideAnimation ng-star-inserted"
                    >
                      <mcd-verify-tips-box
                        _ngcontent-serverapp-c1360517466
                        className="ng-tns-c1360517466-29"
                        _nghost-serverapp-c541140243
                      >
                        <div
                          _ngcontent-serverapp-c541140243
                          className="tips-info verify-tips tips-info-toggle ng-star-inserted"
                          style={{}}
                        >
                          <div
                            _ngcontent-serverapp-c541140243
                            className="title-box"
                          >
                            <h5 _ngcontent-serverapp-c541140243>
                              <i
                                _ngcontent-serverapp-c541140243
                                className="tips-icon"
                                style={{
                                  "mask-image":
                                    'url("/assets/NewImages/icon-tips-type02.webp?v=1776751585885")',
                                }}
                              />
                              <span _ngcontent-serverapp-c541140243>
                                Please complete the verification below before
                                you proceed with the withdrawal request.
                              </span>
                            </h5>
                            <div
                              _ngcontent-serverapp-c541140243
                              className="toggle-btn ng-star-inserted"
                              style={{
                                "mask-image":
                                  'url("/assets/NewImages/icon-arrow-type09.webp?v=1776751585885")',
                              }}
                            />
                          </div>
                          <ol
                            _ngcontent-serverapp-c541140243
                            className="tips-info-block active"
                          >
                            <li
                              _ngcontent-serverapp-c541140243
                              className="personal-info ng-star-inserted"
                            >
                              <a
                                _ngcontent-serverapp-c541140243
                                className="ng-star-inserted"
                              >
                                <label _ngcontent-serverapp-c541140243>
                                  {" "}
                                  Personal Info{" "}
                                </label>
                                <ul _ngcontent-serverapp-c541140243>
                                  <li
                                    _ngcontent-serverapp-c541140243
                                    className="ng-star-inserted"
                                  >
                                    Full Name
                                  </li>
                                  {/**/}
                                  {/**/}
                                </ul>
                              </a>
                              {/**/}
                              {/**/}
                            </li>
                            <li
                              _ngcontent-serverapp-c541140243
                              className="contact-info ng-star-inserted"
                            >
                              <a
                                _ngcontent-serverapp-c541140243
                                className="ng-star-inserted"
                              >
                                <label _ngcontent-serverapp-c541140243>
                                  {" "}
                                  Contact Info{" "}
                                </label>
                                <ul _ngcontent-serverapp-c541140243>
                                  <li
                                    _ngcontent-serverapp-c541140243
                                    className="ng-star-inserted"
                                  >
                                    Phone Number
                                  </li>
                                  {/**/}
                                  {/**/}
                                </ul>
                              </a>
                              {/**/}
                              {/**/}
                            </li>
                            {/**/}
                          </ol>
                        </div>
                        {/**/}
                        {/**/}
                      </mcd-verify-tips-box>
                    </div>
                    {/**/}
                    <div
                      _ngcontent-serverapp-c1360517466
                      className="menu-box unverified-block-personal ng-tns-c1360517466-29 ng-star-inserted"
                    >
                      <div
                        _ngcontent-serverapp-c1360517466
                        className="list-group ng-tns-c1360517466-29"
                        name="Full Name"
                      >
                        <div
                          _ngcontent-serverapp-c1360517466
                          className="icon-block ng-tns-c1360517466-29"
                        >
                          <div
                            _ngcontent-serverapp-c1360517466
                            className="item-icon ng-tns-c1360517466-29"
                            style={{
                              "mask-image":
                                'url("/assets/NewImages/icon-username.webp?v=1776751585885")',
                            }}
                          />
                        </div>
                        <div
                          _ngcontent-serverapp-c1360517466
                          className="list ng-tns-c1360517466-29"
                        >
                          <div
                            _ngcontent-serverapp-c1360517466
                            className="list-info ng-tns-c1360517466-29"
                          >
                            <div
                              _ngcontent-serverapp-c1360517466
                              className="left ng-tns-c1360517466-29"
                            >
                              <div
                                _ngcontent-serverapp-c1360517466
                                className="info-block ng-tns-c1360517466-29"
                              >
                                <div
                                  _ngcontent-serverapp-c1360517466
                                  className="ng-tns-c1360517466-29"
                                >
                                  <label
                                    _ngcontent-serverapp-c1360517466
                                    className="title ng-tns-c1360517466-29"
                                  >
                                    Full Name
                                  </label>
                                  <label
                                    _ngcontent-serverapp-c1360517466
                                    className="ng-tns-c1360517466-29"
                                  />
                                </div>
                                {/**/}
                                {/**/}
                                {/**/}
                              </div>
                            </div>
                            <div
                              _ngcontent-serverapp-c1360517466
                              className="right ng-tns-c1360517466-29"
                            >
                              <button
                                _ngcontent-serverapp-c1360517466
                                className="button ng-tns-c1360517466-29 ng-star-inserted"
                              >
                                Add
                              </button>
                              {/**/}
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* <div
                        _ngcontent-serverapp-c1360517466
                        className="list-group ng-tns-c1360517466-29"
                        name="Phone Number"
                      >
                        <div
                          _ngcontent-serverapp-c1360517466
                          className="icon-block ng-tns-c1360517466-29"
                        >
                          <div
                            _ngcontent-serverapp-c1360517466
                            className="item-icon ng-tns-c1360517466-29"
                            style={{
                              "mask-image":
                                'url("/assets/NewImages/icon-phone.webp?v=1776751585885")',
                            }}
                          />
                        </div>
                        <div
                          _ngcontent-serverapp-c1360517466
                          className="list phone ng-tns-c1360517466-29"
                        >
                          
                          <div
                            _ngcontent-serverapp-c1360517466
                            className="list-info ng-tns-c1360517466-29 ng-star-inserted"
                          >
                            <div
                              _ngcontent-serverapp-c1360517466
                              className="left ng-tns-c1360517466-29"
                            >
                              <div
                                _ngcontent-serverapp-c1360517466
                                className="info-block ng-tns-c1360517466-29"
                              >
                                <div
                                  _ngcontent-serverapp-c1360517466
                                  className="ng-tns-c1360517466-29"
                                >
                                  <label
                                    _ngcontent-serverapp-c1360517466
                                    className="title ng-tns-c1360517466-29"
                                  >
                                    Phone Number{" "}
                                  </label>
                                  
                                </div>
                                <label
                                  _ngcontent-serverapp-c1360517466
                                  className="tips ng-tns-c1360517466-29"
                                >
                                 {profileData?.phone}
                                </label>
                              </div>
                            </div>
                            <div
                              _ngcontent-serverapp-c1360517466
                              className="right ng-tns-c1360517466-29"
                            >
                              <div
                                _ngcontent-serverapp-c1360517466
                                className="status unconfirm-btn ng-tns-c1360517466-29 ng-star-inserted"
                              >
                                {" "}
                                Not Verified{" "}
                              </div>
                              
                            </div>
                          </div>
                         
                          <a
                            _ngcontent-serverapp-c1360517466
                            className="add-phone-btn ng-tns-c1360517466-29"
                          >
                            <div
                              _ngcontent-serverapp-c1360517466
                              className="icon-add-phone-btn ng-tns-c1360517466-29"
                            />
                            <p
                              _ngcontent-serverapp-c1360517466
                              className="ng-tns-c1360517466-29"
                            >
                              Add
                            </p>
                          </a>
                        </div>
                      </div> */}
                      <div
                        _ngcontent-serverapp-c1360517466
                        id="profile-email"
                        className="list-group ng-tns-c1360517466-29"
                        name="E-mail"
                      >
                        <div
                          _ngcontent-serverapp-c1360517466
                          className="icon-block ng-tns-c1360517466-29"
                        >
                          <div
                            _ngcontent-serverapp-c1360517466
                            className="item-icon ng-tns-c1360517466-29"
                            style={{
                              "mask-image":
                                'url("/assets/NewImages/icon-email.webp?v=1776751585885")',
                            }}
                          />
                        </div>
                        <div
                          _ngcontent-serverapp-c1360517466
                          className="list ng-tns-c1360517466-29"
                        >
                          <div
                            _ngcontent-serverapp-c1360517466
                            className="list-info ng-tns-c1360517466-29 ng-star-inserted"
                          >
                            <div
                              _ngcontent-serverapp-c1360517466
                              className="left ng-tns-c1360517466-29"
                            >
                              <div
                                _ngcontent-serverapp-c1360517466
                                className="info-block ng-tns-c1360517466-29"
                              >
                                <div
                                  _ngcontent-serverapp-c1360517466
                                  className="ng-tns-c1360517466-29"
                                >
                                  <label
                                    _ngcontent-serverapp-c1360517466
                                    className="title ng-tns-c1360517466-29"
                                  >
                                    Email
                                  </label>
                                </div>
                                <label
                                  _ngcontent-serverapp-c1360517466
                                  className="tips ng-tns-c1360517466-29"
                                />
                              </div>
                            </div>
                            <div
                              _ngcontent-serverapp-c1360517466
                              className="right ng-tns-c1360517466-29"
                            >
                              <button
                                _ngcontent-serverapp-c1360517466
                                className="button ng-tns-c1360517466-29"
                              >
                                Add
                              </button>
                            </div>
                          </div>
                          {/**/}
                          {/**/}
                          {/**/}
                        </div>
                      </div>
                      {/**/}
                      {/**/}
                    </div>
                    <div
                      _ngcontent-serverapp-c1360517466
                      className="member-menu-point ng-tns-c1360517466-29 ng-star-inserted"
                    >
                      <i
                        _ngcontent-serverapp-c1360517466
                        className="ng-tns-c1360517466-29"
                      >
                        <span
                          _ngcontent-serverapp-c1360517466
                          className="item-icon ng-tns-c1360517466-29"
                          style={{
                            "background-image":
                              'url("/assets/NewImages/icon-customer.webp?v=1776751585885")',
                          }}
                        />
                      </i>
                      <p
                        _ngcontent-serverapp-c1360517466
                        className="ng-tns-c1360517466-29"
                      >
                        For privacy and security, Information can’t modified
                        after confirmation. Please{" "}
                        <span
                          _ngcontent-serverapp-c1360517466
                          name="liveChatBtn"
                          className="ng-tns-c1360517466-29"
                        >
                          contact customer service
                        </span>{" "}
                        .
                      </p>
                    </div>
                    {/**/}
                    {/**/}
                    {/**/}
                    {/**/}
                    {/**/}
                  </ng-component>
                  {/**/}
                </ng-component>
                {/**/}
              </div>
            </div>
          </div>
        </ConditionalOutsideClick>
      </div>
    </app-popup-page>,
    document.getElementById("overlay"),
  );
};

export default Profile;
